import { DateTime } from 'luxon';

export const toLocaleDate = (
  date: string | number,
  format = DateTime.DATETIME_MED,
) => {
  if (typeof date === 'number') {
    return DateTime.fromMillis(date).toLocaleString(format);
  }
  return DateTime.fromISO(date).toLocaleString(format);
};

export const getLocaleDateFormatPlaceholder = (locale?: string) => {
  const formatter = new Intl.DateTimeFormat(locale);
  const parts = formatter.formatToParts(new Date(1999, 10, 22));

  return parts
    .map((part) => {
      switch (part.type) {
        case 'year':
          return 'YYYY';
        case 'month':
          return 'MM';
        case 'day':
          return 'DD';
        default:
          return part.value;
      }
    })
    .join('');
};
